import React, { Component } from "react";
import { Lottie } from "@crello/react-lottie";

const animations = {
  1: require("../../../animations/loading.json"),
  2: require("../../../animations/project1.json"),
  3: require("../../../animations/project2.json"),
  4: require("../../../animations/project3.json"),
  5: require("../../../animations/cloud.json"),
  6: require("../../../animations/unlock.json"),
};

class Animation extends Component {
  constructor(props) {
    super(props);
    this.state = { isStopped: false, isPaused: false };
  }
  render() {
    const defaultOptions = {
      loop: this.props.loop,
      autoplay: true,
      animationData: animations[this.props.animation || 1],
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <Lottie
        className="mx-auto"
        style={{ maxWidth: "100%" }}
        config={defaultOptions}
        height={this.props.height || 400}
        width={this.props.width || 400}
        isStopped={this.state.isStopped}
        isPaused={this.state.isPaused}
      />
    );
  }
}

Animation.defaultProps = {
  loop: true,
};

export default Animation;
